import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Format a date string for display.
 * Returns empty string for null/1900-01-01 dates.
 * Strips time portion, returns date part only (YYYY-MM-DD).
 */
export function formatDate(dateStr) {
	if (!dateStr || dateStr === '1900-01-01' || dateStr.startsWith('1900-01-01')) return '';
	return dateStr.split(' ')[0];
}

/**
 * Format a date string for display, returns 'N/A' for null/1900-01-01 dates.
 * Used in detail pages where empty fields should show 'N/A'.
 */
export function formatDateOrNA(dateStr) {
	if (!dateStr || dateStr === '1900-01-01' || dateStr.startsWith('1900-01-01')) return 'N/A';
	return dateStr.split(' ')[0];
}

/**
 * Format a date string to US locale (MM/DD/YYYY).
 * Used in search result columns for user-friendly display.
 */
export function formatDateLocale(dateStr) {
	if (!dateStr || dateStr === '1900-01-01' || dateStr.startsWith('1900-01-01')) return '';
	const d = new Date(dateStr);
	if (isNaN(d.getTime())) return '';
	return d.toLocaleDateString('en-US');
}

/**
 * Simple label/value detail field component.
 * Reused across BulletinDetail and PromotionDetail pages.
 */
export function DetailField({ label, value }) {
	return (
		<Box>
			<Typography variant="subtitle2" color="text.secondary">{label}</Typography>
			<Typography variant="body1">{value || 'N/A'}</Typography>
		</Box>
	);
}

/**
 * Section labels for promotion summary points.
 * Maps promo_bullet_id to human-readable section names.
 * Used in PromotionDetail, PromotionEdit, and BulletinReport.
 */
export const POINT_SECTIONS = {
	'1': '01 - Bulletin/Promotion Overview',
	'2': '02 - Model/List Price/Dealer Price',
	'3': '03 - Spiff Payment (Model, Reseller Credit, Salesperson)',
	'4': '04 - Claim Deadline',
};

/**
 * Section config for PromotionEdit form (includes state key mapping).
 */
export const POINT_SECTIONS_EDIT = [
	{ id: '1', label: '01 - Bulletin/Promotion Overview', stateKey: 'section1' },
	{ id: '2', label: '02 - Model/List Price/Dealer Price', stateKey: 'section2' },
	{ id: '3', label: '03 - Spiff Payment (Model, Reseller Credit, Salesperson)', stateKey: 'section3' },
	{ id: '4', label: '04 - Claim Deadline', stateKey: 'section4' },
];
